module.exports = __webpack_public_path__ + "img/completed-metric-texture.e36a0113.svg";